import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { ToastPosition, CapturumSharedModule } from '@capturum/ui/api';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from 'primeng/toast';
import { ToastModule } from 'primeng/toast';
import * as i3 from 'primeng/api';
const _c0 = function (a0, a1, a2, a3) {
  return {
    "fa-check-circle": a0,
    "fa-exclamation-circle": a1,
    "fa-times-circle": a2,
    "fa-info-circle": a3
  };
};
function CapturumToastComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "i", 3);
    i0.ɵɵelementStart(2, "div", 4)(3, "h3", 5);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "span", 6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const message_r1 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(3, _c0, message_r1.severity === "success", message_r1.severity === "warn", message_r1.severity === "error", message_r1.severity === "info"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(message_r1.summary);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", message_r1.detail, i0.ɵɵsanitizeHtml);
  }
}
let CapturumToastComponent = /*#__PURE__*/(() => {
  class CapturumToastComponent {
    constructor() {
      /**
       * Position of the component, valid values are "top-right", "top-left", "bottom-left", "bottom-right", "top-center, "bottom-center" and "center".
       */
      this.position = ToastPosition.TOP_RIGHT;
      /**
       * Style class of the component.
       */
      this.styleClass = '';
      /**
       * Callback to invoke when a message is closed.
       */
      this.onClose = new EventEmitter();
    }
    static {
      this.ɵfac = function CapturumToastComponent_Factory(t) {
        return new (t || CapturumToastComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumToastComponent,
        selectors: [["cap-toast"]],
        inputs: {
          key: "key",
          position: "position",
          styleClass: "styleClass"
        },
        outputs: {
          onClose: "onClose"
        },
        decls: 2,
        vars: 3,
        consts: [[3, "styleClass", "position", "key", "onClose"], ["pTemplate", "message"], [1, "d-flex"], [1, "toast-icon", "d-flex", "justify-content-center", "flex-column", "fas", 3, "ngClass"], [1, "toast-content"], [1, "toast-summary"], [1, "toast-detail", 3, "innerHTML"]],
        template: function CapturumToastComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "p-toast", 0);
            i0.ɵɵlistener("onClose", function CapturumToastComponent_Template_p_toast_onClose_0_listener() {
              return ctx.onClose.emit();
            });
            i0.ɵɵtemplate(1, CapturumToastComponent_ng_template_1_Template, 6, 8, "ng-template", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("styleClass", "cap-toast " + ctx.styleClass)("position", ctx.position)("key", ctx.key);
          }
        },
        dependencies: [i1.NgClass, i2.Toast, i3.PrimeTemplate],
        styles: [".toast-success[_ngcontent-%COMP%]{display:flex;width:400px;min-height:200px;padding:16px 18px;border-radius:5px;box-sizing:border-box;background-color:#e4fae8;box-shadow:0 5px 13px #4cd96426;color:var(--success-color);border:1px solid var(--success-color)}.toast-success[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .type[_ngcontent-%COMP%]{width:46px;box-sizing:border-box;display:table;height:46px;line-height:46px;border-radius:100%;text-align:center;border:1px solid var(--success-color)}.toast-success[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .type[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{display:table-cell;vertical-align:middle}.toast-success[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]{margin-left:20px}.toast-success[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{min-height:46px}.toast-success[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{margin:0;padding:11px 0;font-size:toRem(22px)}.toast-success[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]{margin-top:10px}.toast-success[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0;font-size:toRem(16px)}.toast-warning[_ngcontent-%COMP%]{display:flex;width:400px;min-height:200px;padding:16px 18px;border-radius:5px;box-sizing:border-box;background-color:#ffe4bf;box-shadow:0 5px 13px #ff950026;color:var(--warning-color);border:1px solid var(--warning-color)}.toast-warning[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .type[_ngcontent-%COMP%]{width:46px;box-sizing:border-box;display:table;height:46px;line-height:46px;border-radius:100%;text-align:center;border:1px solid var(--warning-color)}.toast-warning[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .type[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{display:table-cell;vertical-align:middle}.toast-warning[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]{margin-left:20px}.toast-warning[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{min-height:46px}.toast-warning[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{margin:0;padding:11px 0;font-size:toRem(22px)}.toast-warning[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]{margin-top:10px}.toast-warning[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0;font-size:toRem(16px)}.toast-info[_ngcontent-%COMP%]{display:flex;width:400px;min-height:200px;padding:16px 18px;border-radius:5px;box-sizing:border-box;background-color:#fbe5ed;box-shadow:0 5px 13px #dd005326;color:var(--info-color);border:1px solid var(--info-color)}.toast-info[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .type[_ngcontent-%COMP%]{width:46px;box-sizing:border-box;display:table;height:46px;line-height:46px;border-radius:100%;text-align:center;border:1px solid var(--info-color)}.toast-info[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .type[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{display:table-cell;vertical-align:middle}.toast-info[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]{margin-left:20px}.toast-info[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{min-height:46px}.toast-info[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{margin:0;padding:11px 0;font-size:toRem(22px)}.toast-info[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]{margin-top:10px}.toast-info[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0;font-size:toRem(16px)}.toast-error[_ngcontent-%COMP%]{display:flex;width:400px;min-height:200px;padding:16px 18px;border-radius:5px;box-sizing:border-box;background-color:#ffcecb;box-shadow:0 5px 13px #ff3b3026;color:var(--error-color);border:1px solid var(--error-color)}.toast-error[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .type[_ngcontent-%COMP%]{width:46px;box-sizing:border-box;display:table;height:46px;line-height:46px;border-radius:100%;text-align:center;border:1px solid var(--error-color)}.toast-error[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%]   .type[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{display:table-cell;vertical-align:middle}.toast-error[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]{margin-left:20px}.toast-error[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{min-height:46px}.toast-error[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{margin:0;padding:11px 0;font-size:toRem(22px)}.toast-error[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]{margin-top:10px}.toast-error[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%]   .message[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0;font-size:toRem(16px)}"]
      });
    }
  }
  return CapturumToastComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumToastModule = /*#__PURE__*/(() => {
  class CapturumToastModule {
    static {
      this.ɵfac = function CapturumToastModule_Factory(t) {
        return new (t || CapturumToastModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CapturumToastModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, ToastModule, CapturumSharedModule]
      });
    }
  }
  return CapturumToastModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CapturumToastComponent, CapturumToastModule };
